export default "__VITE_ASSET__BQEv1fll__"